import { gql } from '@apollo/client'

export const ADD_ORDER_SERVICE_LINE_ITEM = gql`
  mutation AddOrderServiceLineItem($orderNumber: String!, $serviceExternalId: String!, $quantity: Float) {
    addOrderServiceLineItem(orderNumber: $orderNumber, serviceExternalId: $serviceExternalId, quantity: $quantity) {
      serviceLineItem {
        id
        name
        quantity
        unit
        cost
        singlePrice
        totalPrice
        serviceId
      }
      order {
        id
      }
      errors
    }
  }
`
